/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMarketingCouponOfferDetailsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetMarketingCouponOfferDetailsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getMarketingCouponOfferDetails = (request: GetMarketingCouponOfferDetailsRequest, options?: CashRequestOptions) => post<GetMarketingCouponOfferDetailsRequest, GetMarketingCouponOfferDetailsResponse>("/cash-app/local/coupon-offer-details", request, {...options, rejectOnError: true })